import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/logo-final.png'


const _hoisted_1 = { class: "bg-cream-100 overflow-hidden" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20" }
const _hoisted_3 = { class: "flex flex-col lg:flex-row items-center gap-10 lg:gap-16" }
const _hoisted_4 = { class: "flex-1 text-center lg:text-left" }
const _hoisted_5 = { class: "flex flex-col sm:flex-row gap-3 justify-center lg:justify-start" }
const _hoisted_6 = { class: "mt-8 flex flex-wrap justify-center lg:justify-start gap-4 sm:gap-6 lg:gap-8" }
const _hoisted_7 = { class: "font-display text-2xl font-bold text-brand" }
const _hoisted_8 = { class: "text-sm text-accent/60 mt-0.5" }
const _hoisted_9 = { class: "flex-1 w-full max-w-md lg:max-w-none" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = { class: "card p-6 bg-white" }
const _hoisted_12 = { class: "flex items-center justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "badge mb-4 inline-block" }, " 🍽️ Today's Menu is Live! ", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-accent leading-tight mb-4" }, [
            _createTextVNode(" Fresh Home-Cooked"),
            _createElementVNode("br"),
            _createElementVNode("span", { class: "text-brand" }, "Meals Delivered"),
            _createTextVNode(" To Your Door ")
          ], -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-accent/70 text-base sm:text-lg mb-6 sm:mb-8 max-w-lg mx-auto lg:mx-0" }, " Every day we cook a new menu — real home food made with love. Browse today's dishes, place your order, and we'll deliver it fresh. ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/menu",
              class: "btn-primary text-base px-8 py-3"
            }, {
              default: _withCtx(() => [
                _cache[0] || (_cache[0] = _createElementVNode("span", null, "See Today's Menu", -1)),
                _createVNode(_component_ArrowRightIcon, { class: "w-5 h-5" })
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/about",
              class: "btn-outline text-base px-8 py-3"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" How It Works ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, (stat) => {
              return (_openBlock(), _createElementBlock("div", {
                key: stat.label,
                class: "text-center lg:text-left"
              }, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(stat.value), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(stat.label), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "bg-cream-200 rounded-2xl h-52 sm:h-64 md:h-72 lg:h-80 flex items-center justify-center mb-4" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "HomeSweet Bites — Home Cooked Meals",
                  class: "h-48 w-auto object-contain drop-shadow-lg"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_12, [
                _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                  _createElementVNode("p", { class: "text-xs text-accent/50 font-medium uppercase tracking-wide" }, "Today's Special"),
                  _createElementVNode("p", { class: "font-display font-bold text-accent text-lg" }, "Chef's Daily Plate")
                ], -1)),
                _createVNode(_component_router_link, {
                  to: "/menu",
                  class: "btn-primary text-sm px-4 py-2"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" Order ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "absolute -top-4 -right-4 bg-brand text-white rounded-2xl px-4 py-2 shadow-lg text-sm font-semibold hidden sm:block" }, " 🛵 Fast Delivery ", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "absolute -bottom-4 -left-4 bg-white rounded-2xl px-4 py-3 shadow-card text-sm font-semibold text-accent flex items-center gap-2 hidden sm:flex" }, [
              _createElementVNode("span", { class: "text-yellow-400 text-base" }, "★★★★★"),
              _createElementVNode("span", null, "4.9 Rating")
            ], -1))
          ])
        ])
      ])
    ])
  ]))
}